import { MembershipInstanceLine } from '@kalos/kalos-rpc';
import { useQuery } from '@tanstack/react-query';

import { queryKeys } from '../../../hooks/react-query/constants';
import { MembershipClientService } from '../../../tools/helpers';

/** Frozen line items for one membership; shared so every reader hits one cache entry. */
export const instanceLinesQueryOptions = (membershipId: number) => ({
  queryKey: [queryKeys.memberships.root, 'instanceLines', membershipId],
  queryFn: async () => {
    const list = await MembershipClientService.BatchGetMembershipInstanceLine(
      MembershipInstanceLine.create({ membershipId, withoutLimit: true }),
    );
    return (list?.results ?? []).slice().sort((a, b) => a.sortOrder - b.sortOrder);
  },
});

/** Frozen line items for one membership, fetched when its accordion row opens. */
export const useInstanceLines = (membershipId: number, enabled: boolean) =>
  useQuery({
    ...instanceLinesQueryOptions(membershipId),
    enabled: enabled && membershipId > 0,
  });
